import React from 'react'
import { Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import { useTranslation } from 'react-i18next'

interface BackToMainPageLinkProps {
  uuid: string
}

const BackToMainPageLink = ({ uuid }: BackToMainPageLinkProps): JSX.Element => {
  const { t } = useTranslation('repairshop')
  return (
    <Link
      to={`/${uuid}`}
      style={{ display: 'inline-block' }}
      data-testid={'back-to-main-page'}
    >
      <Stack
        direction={'row'}
        alignItems={'center'}
        sx={{
          color: 'primary.main',
          '& .MuiSvgIcon-root': { fontSize: 20, marginRight: 1 },
        }}
      >
        <ArrowBackIcon />
        <Typography variant="body1" component="p">
          {t('pre-commit-page.back-to-main-page')}
        </Typography>
      </Stack>
    </Link>
  )
}

export default BackToMainPageLink
